export const Rectangle = ({ ...props }) => {
  return (
    <>
      <svg
        onClick={props.onClick}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M22 3H2V21H22V3Z"
          stroke="#585858"
          className={"icon_stroke"}
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};

export const RoundedRectangle = ({ ...props }) => {
  return (
    <>
      <svg
        onClick={props.onClick}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18 3H6C3.79086 3 2 4.79086 2 7V17C2 19.2091 3.79086 21 6 21H18C20.2091 21 22 19.2091 22 17V7C22 4.79086 20.2091 3 18 3Z"
          stroke="#585858"
          className={"icon_stroke"}
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};

export const SnipSingleCorner = ({ ...props }) => {
  return (
    <>
      <svg
        onClick={props.onClick}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2 21H22V10.2L13.8182 3H2V21Z"
          stroke="#585858"
          className={"icon_stroke"}
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};

export const SnipSameSide = ({ ...props }) => {
  return (
    <>
      <svg
        onClick={props.onClick}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2 21H22V9.3L16.5455 3H7.45455L2 9.3V21Z"
          stroke="#585858"
          className={"icon_stroke"}
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};

export const SnipDiagonal = ({ ...props }) => {
  return (
    <>
      <svg
        onClick={props.onClick}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M9.27273 21H22V9.3L14.7273 3H2V14.7L9.27273 21Z"
          stroke="#585858"
          className={"icon_stroke"}
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};

export const SnipAndRoundSingle = ({ ...props }) => {
  return (
    <>
      <svg
        onClick={props.onClick}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.8182 3L14.1485 2.62464C14.0572 2.54431 13.9398 2.5 13.8182 2.5V3ZM22 21V21.5C22.2761 21.5 22.5 21.2761 22.5 21H22ZM2 21H1.5C1.5 21.2761 1.72386 21.5 2 21.5V21ZM22 10.2H22.5C22.5 10.0563 22.4382 9.91957 22.3303 9.82464L22 10.2ZM22 20.5H2V21.5H22V20.5ZM2.5 21V9H1.5V21H2.5ZM8 3.5H13.8182V2.5H8V3.5ZM13.4879 3.37536L21.6697 10.5754L22.3303 9.82464L14.1485 2.62464L13.4879 3.37536ZM21.5 10.2V21H22.5V10.2H21.5ZM2.5 9C2.5 5.96243 4.96243 3.5 8 3.5V2.5C4.41015 2.5 1.5 5.41015 1.5 9H2.5Z"
          fill="#585858"
          className={"icon_fill"}
        />
      </svg>
    </>
  );
};

export const RoundSingle = ({ ...props }) => {
  return (
    <>
      <svg
        onClick={props.onClick}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2 3V2.5C1.72386 2.5 1.5 2.72386 1.5 3H2ZM22 21V21.5C22.2761 21.5 22.5 21.2761 22.5 21H22ZM2 21H1.5C1.5 21.2761 1.72386 21.5 2 21.5V21ZM2 3.5H14V2.5H2V3.5ZM21.5 11V21H22.5V11H21.5ZM22 20.5H2V21.5H22V20.5ZM2.5 21V3H1.5V21H2.5ZM14 3.5C18.1421 3.5 21.5 6.85786 21.5 11H22.5C22.5 6.30558 18.6944 2.5 14 2.5V3.5Z"
          fill="#585858"
          className={"icon_fill"}
        />
      </svg>
    </>
  );
};

export const RoundSameSide = ({ ...props }) => {
  return (
    <>
      <svg
        onClick={props.onClick}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M22 21V21.5C22.2761 21.5 22.5 21.2761 22.5 21H22ZM2 21H1.5C1.5 21.2761 1.72386 21.5 2 21.5V21ZM10 3.5H14V2.5H10V3.5ZM21.5 11V21H22.5V11H21.5ZM22 20.5H2V21.5H22V20.5ZM2.5 21V11H1.5V21H2.5ZM14 3.5C18.1421 3.5 21.5 6.85786 21.5 11H22.5C22.5 6.30558 18.6944 2.5 14 2.5V3.5ZM10 2.5C5.30558 2.5 1.5 6.30558 1.5 11H2.5C2.5 6.85786 5.85786 3.5 10 3.5V2.5Z"
          fill="#585858"
          className={"icon_fill"}
        />
      </svg>
    </>
  );
};

export const RoundDiagonal = ({ ...props }) => {
  return (
    <>
      <svg
        onClick={props.onClick}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M22 3H22.5C22.5 2.72386 22.2761 2.5 22 2.5V3ZM2 21H1.5C1.5 21.2761 1.72386 21.5 2 21.5V21ZM10 3.5H22V2.5H10V3.5ZM21.5 3V13H22.5V3H21.5ZM14 20.5H2V21.5H14V20.5ZM2.5 21V11H1.5V21H2.5ZM21.5 13C21.5 17.1421 18.1421 20.5 14 20.5V21.5C18.6944 21.5 22.5 17.6944 22.5 13H21.5ZM10 2.5C5.30558 2.5 1.5 6.30558 1.5 11H2.5C2.5 6.85786 5.85786 3.5 10 3.5V2.5Z"
          fill="#585858"
          className={"icon_fill"}
        />
      </svg>
    </>
  );
};

export const Oval = ({ ...props }) => {
  return (
    <>
      <svg
        onClick={props.onClick}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="12" cy="12" r="10" stroke="#585858" className={"icon_stroke"} />
      </svg>
    </>
  );
};

export const Triangle = ({ ...props }) => {
  return (
    <>
      <svg
        onClick={props.onClick}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M22 22L2 22L12 2L22 22Z"
          stroke="#585858"
          className={"icon_stroke"}
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};

export const RightTriangle = ({ ...props }) => {
  return (
    <>
      <svg
        onClick={props.onClick}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M22 22L2 22L2 2L22 22Z"
          stroke="#585858"
          className={"icon_stroke"}
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};

export const Parallelogram = ({ ...props }) => {
  return (
    <>
      <svg
        onClick={props.onClick}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M22 3H7.45455L2 21H16.5455L22 3Z"
          stroke="#585858"
          className={"icon_stroke"}
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};

export const Trapezoid = ({ ...props }) => {
  return (
    <>
      <svg
        onClick={props.onClick}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18.3636 3H5.63636L2 21H22L18.3636 3Z"
          stroke="#585858"
          className={"icon_stroke"}
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};

export const Diamond = ({ ...props }) => {
  return (
    <>
      <svg
        onClick={props.onClick}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M22 12L12 2L2 12L12 22L22 12Z"
          stroke="#585858"
          className={"icon_stroke"}
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};

export const Pentagon = ({ ...props }) => {
  return (
    <>
      <svg
        onClick={props.onClick}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5.63636 22H18.3636L22 11.0909L12 2L2 11.0909L5.63636 22Z"
          stroke="#585858"
          className={"icon_stroke"}
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};

export const Hexagon = ({ ...props }) => {
  return (
    <>
      <svg
        onClick={props.onClick}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.45455 21H16.5455L22 12L16.5455 3H7.45455L2 12L7.45455 21Z"
          stroke="#585858"
          className={"icon_stroke"}
          strokeLinejoin="round"
        />
        <path
          d="M9.5 12.1895C9.5 9.39648 10.6377 8 12.9131 8C13.2712 8 13.5739 8.02767 13.8213 8.08301V9.04004C13.5739 8.96842 13.2874 8.93262 12.9619 8.93262C12.1969 8.93262 11.6224 9.1377 11.2383 9.54785C10.8542 9.95801 10.6458 10.6156 10.6133 11.5205H10.6719C10.8249 11.2568 11.0397 11.0534 11.3164 10.9102C11.5931 10.7637 11.9186 10.6904 12.293 10.6904C12.9408 10.6904 13.4453 10.889 13.8066 11.2861C14.168 11.6833 14.3486 12.222 14.3486 12.9023C14.3486 13.651 14.1387 14.2435 13.7188 14.6797C13.3021 15.1126 12.7324 15.3291 12.0098 15.3291C11.4987 15.3291 11.0544 15.207 10.6768 14.9629C10.2992 14.7155 10.0078 14.3574 9.80273 13.8887C9.60091 13.4167 9.5 12.8503 9.5 12.1895ZM11.9902 14.3818C12.3841 14.3818 12.6868 14.2549 12.8984 14.001C13.1133 13.7471 13.2207 13.3841 13.2207 12.9121C13.2207 12.502 13.1198 12.1797 12.918 11.9453C12.7194 11.7109 12.4199 11.5938 12.0195 11.5938C11.7721 11.5938 11.5443 11.6475 11.3359 11.7549C11.1276 11.859 10.9632 12.0039 10.8428 12.1895C10.7223 12.3717 10.6621 12.5589 10.6621 12.751C10.6621 13.21 10.7858 13.5973 11.0332 13.9131C11.2839 14.2256 11.6029 14.3818 11.9902 14.3818Z"
          fill="#585858"
          className={"icon_fill"}
        />
      </svg>
    </>
  );
};

export const Heptagon = ({ ...props }) => {
  return (
    <>
      <svg
        onClick={props.onClick}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.45455 21H16.5455L22 12L16.5455 3H7.45455L2 12L7.45455 21Z"
          stroke="#585858"
          className={"icon_stroke"}
          strokeLinejoin="round"
        />
        <path
          d="M10.4189 15.5588L13.2412 9.44067H9.53027V8.42993H14.4668V9.23071L11.6592 15.5588H10.4189Z"
          fill="#585858"
          className={"icon_fill"}
        />
      </svg>
    </>
  );
};

export const Octagon = ({ ...props }) => {
  return (
    <>
      <svg
        onClick={props.onClick}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.45455 22H16.5455L22 16.5455V7.45455L16.5455 2H7.45455L2 7.45455V16.5455L7.45455 22Z"
          stroke="#585858"
          className={"icon_stroke"}
          strokeLinejoin="round"
        />
        <path
          d="M12.002 8.30005C12.679 8.30005 13.2145 8.4563 13.6084 8.7688C14.0023 9.07804 14.1992 9.49308 14.1992 10.0139C14.1992 10.7463 13.7598 11.329 12.8809 11.762C13.4408 12.0419 13.8379 12.3365 14.0723 12.6458C14.3099 12.955 14.4287 13.3 14.4287 13.6809C14.4287 14.2701 14.2122 14.7421 13.7793 15.0969C13.3464 15.4517 12.7604 15.6292 12.0215 15.6292C11.2467 15.6292 10.6462 15.4631 10.2197 15.1311C9.79329 14.7991 9.58008 14.3287 9.58008 13.72C9.58008 13.3228 9.69076 12.9664 9.91211 12.6506C10.1367 12.3316 10.5029 12.0484 11.0107 11.801C10.5745 11.5406 10.2637 11.2655 10.0781 10.9758C9.89258 10.6861 9.7998 10.3606 9.7998 9.99927C9.7998 9.48169 10.0033 9.06991 10.4102 8.76392C10.8171 8.45467 11.3477 8.30005 12.002 8.30005ZM10.6787 13.6809C10.6787 14.0194 10.7975 14.2831 11.0352 14.4719C11.2728 14.6575 11.5951 14.7502 12.002 14.7502C12.4219 14.7502 12.7474 14.6542 12.9785 14.4622C13.2129 14.2668 13.3301 14.0032 13.3301 13.6711C13.3301 13.4075 13.2227 13.1666 13.0078 12.9485C12.793 12.7304 12.4674 12.5286 12.0312 12.343L11.8896 12.2795C11.46 12.4683 11.1507 12.6767 10.9619 12.9045C10.7731 13.1292 10.6787 13.3879 10.6787 13.6809ZM11.9922 9.18384C11.6667 9.18384 11.4046 9.26522 11.2061 9.42798C11.0075 9.58748 10.9082 9.80558 10.9082 10.0823C10.9082 10.2515 10.944 10.4029 11.0156 10.5364C11.0872 10.6698 11.1914 10.7919 11.3281 10.9026C11.4648 11.01 11.696 11.1402 12.0215 11.2932C12.4121 11.1207 12.6872 10.94 12.8467 10.7512C13.0094 10.5592 13.0908 10.3362 13.0908 10.0823C13.0908 9.80558 12.9899 9.58748 12.7881 9.42798C12.5895 9.26522 12.3242 9.18384 11.9922 9.18384Z"
          fill="#585858"
          className={"icon_fill"}
        />
      </svg>
    </>
  );
};

export const Decagon = ({ ...props }) => {
  return (
    <>
      <svg
        onClick={props.onClick}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.45455 22H16.5455L22 16.5455V7.45455L16.5455 2H7.45455L2 7.45455V16.5455L7.45455 22Z"
          stroke="#585858"
          className={"icon_stroke"}
          strokeLinejoin="round"
        />
        <path
          d="M9.93652 15.551H8.78906V10.9417C8.78906 10.3915 8.80208 9.95532 8.82812 9.63306C8.75326 9.71118 8.66048 9.79744 8.5498 9.89185C8.44238 9.98625 8.0778 10.2857 7.45605 10.7903L6.87988 10.0627L8.97949 8.41235H9.93652V15.551Z"
          fill="#585858"
          className={"icon_fill"}
        />
        <path
          d="M17.1191 11.9817C17.1191 13.2219 16.9189 14.1431 16.5186 14.7454C16.1214 15.3476 15.5127 15.6487 14.6924 15.6487C13.8981 15.6487 13.2959 15.3378 12.8857 14.7161C12.4756 14.0943 12.2705 13.1829 12.2705 11.9817C12.2705 10.7219 12.4691 9.79419 12.8662 9.19849C13.2666 8.59953 13.8753 8.30005 14.6924 8.30005C15.4899 8.30005 16.0938 8.61255 16.5039 9.23755C16.9141 9.86255 17.1191 10.7773 17.1191 11.9817ZM13.4326 11.9817C13.4326 12.955 13.5319 13.65 13.7305 14.0667C13.9323 14.4833 14.2529 14.6917 14.6924 14.6917C15.1318 14.6917 15.4525 14.4801 15.6543 14.0569C15.8594 13.6337 15.9619 12.942 15.9619 11.9817C15.9619 11.0247 15.8594 10.3329 15.6543 9.90649C15.4525 9.47681 15.1318 9.26196 14.6924 9.26196C14.2529 9.26196 13.9323 9.47192 13.7305 9.89185C13.5319 10.3118 13.4326 11.0084 13.4326 11.9817Z"
          fill="#585858"
          className={"icon_fill"}
        />
      </svg>
    </>
  );
};

export const Dodecagon = ({ ...props }) => {
  return (
    <>
      <svg
        onClick={props.onClick}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.45455 22H16.5455L22 16.5455V7.45455L16.5455 2H7.45455L2 7.45455V16.5455L7.45455 22Z"
          stroke="#585858"
          className={"icon_stroke"}
          strokeLinejoin="round"
        />
        <path
          d="M9.93652 15.6013H8.78906V10.9919C8.78906 10.4418 8.80208 10.0056 8.82812 9.68335C8.75326 9.76147 8.66048 9.84774 8.5498 9.94214C8.44238 10.0365 8.0778 10.336 7.45605 10.8406L6.87988 10.113L8.97949 8.46265H9.93652V15.6013Z"
          fill="#585858"
          className={"icon_fill"}
        />
        <path
          d="M17.1191 15.6013H12.2803V14.7322L14.1211 12.8816C14.6647 12.325 15.0244 11.9311 15.2002 11.7C15.3792 11.4656 15.5094 11.2458 15.5908 11.0408C15.6722 10.8357 15.7129 10.616 15.7129 10.3816C15.7129 10.0593 15.6152 9.80542 15.4199 9.61987C15.2279 9.43433 14.9609 9.34155 14.6191 9.34155C14.3457 9.34155 14.0804 9.39201 13.8232 9.49292C13.5693 9.59383 13.2747 9.77612 12.9395 10.0398L12.3193 9.28296C12.7165 8.94767 13.1022 8.71004 13.4766 8.57007C13.8509 8.43009 14.2497 8.36011 14.6729 8.36011C15.3369 8.36011 15.8691 8.53426 16.2695 8.88257C16.6699 9.22762 16.8701 9.69312 16.8701 10.2791C16.8701 10.6013 16.8115 10.9073 16.6943 11.197C16.5804 11.4867 16.403 11.7862 16.1621 12.0955C15.9245 12.4014 15.5273 12.8165 14.9707 13.3406L13.7305 14.5417V14.5906H17.1191V15.6013Z"
          fill="#585858"
          className={"icon_fill"}
        />
      </svg>
    </>
  );
};

export const Pie = ({ ...props }) => {
  return (
    <>
      <svg
        onClick={props.onClick}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 2C10.0222 2 8.08879 2.58649 6.4443 3.6853C4.79981 4.78412 3.51808 6.3459 2.7612 8.17317C2.00433 10.0004 1.80629 12.0111 2.19215 13.9509C2.578 15.8907 3.53041 17.6725 4.92893 19.0711C6.32746 20.4696 8.10929 21.422 10.0491 21.8079C11.9889 22.1937 13.9996 21.9957 15.8268 21.2388C17.6541 20.4819 19.2159 19.2002 20.3147 17.5557C21.4135 15.9112 22 13.9778 22 12H12L12 2Z"
          stroke="#585858"
          className={"icon_stroke"}
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};

export const Arc = ({ ...props }) => {
  return (
    <>
      <svg
        onClick={props.onClick}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 2C13.3132 2 14.6136 2.25866 15.8268 2.7612C17.0401 3.26375 18.1425 4.00035 19.0711 4.92893C19.9997 5.85752 20.7362 6.95991 21.2388 8.17317C21.7413 9.38642 22 10.6868 22 12"
          stroke="#585858"
          className={"icon_stroke"}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};

export const Chord = ({ ...props }) => {
  return (
    <>
      <svg
        onClick={props.onClick}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 2L12.441 1.7643C12.354 1.60159 12.1845 1.5 12 1.5V2ZM20.3147 17.5557L20.7304 17.8335C20.8329 17.6801 20.8426 17.4827 20.7557 17.32L20.3147 17.5557ZM12 1.5C9.9233 1.5 7.89323 2.11581 6.16652 3.26957L6.72209 4.10104C8.28435 3.05717 10.1211 2.5 12 2.5V1.5ZM6.16652 3.26957C4.4398 4.42332 3.09399 6.0632 2.29927 7.98182L3.22315 8.36451C3.94218 6.62861 5.15982 5.14491 6.72209 4.10104L6.16652 3.26957ZM2.29927 7.98182C1.50455 9.90045 1.29661 12.0116 1.70176 14.0484L2.68254 13.8534C2.31598 12.0105 2.50412 10.1004 3.22315 8.36451L2.29927 7.98182ZM1.70176 14.0484C2.1069 16.0852 3.10693 17.9562 4.57538 19.4246L5.28249 18.7175C3.95389 17.3889 3.0491 15.6962 2.68254 13.8534L1.70176 14.0484ZM4.57538 19.4246C6.04383 20.8931 7.91476 21.8931 9.95156 22.2982L10.1466 21.3175C8.30383 20.9509 6.61109 20.0461 5.28249 18.7175L4.57538 19.4246ZM9.95156 22.2982C11.9884 22.7034 14.0996 22.4955 16.0182 21.7007L15.6355 20.7769C13.8996 21.4959 11.9895 21.684 10.1466 21.3175L9.95156 22.2982ZM16.0182 21.7007C17.9368 20.906 19.5767 19.5602 20.7304 17.8335L19.899 17.2779C18.8551 18.8402 17.3714 20.0578 15.6355 20.7769L16.0182 21.7007ZM20.7557 17.32L12.441 1.7643L11.559 2.2357L19.8737 17.7914L20.7557 17.32Z"
          fill="#585858"
          className={"icon_fill"}
        />
      </svg>
    </>
  );
};

export const Teardrop = ({ ...props }) => {
  return (
    <>
      <svg
        onClick={props.onClick}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M22 2H22.5C22.5 1.72386 22.2761 1.5 22 1.5V2ZM11.0909 2.5H22V1.5H11.0909V2.5ZM21.5 2V12.9091H22.5V2H21.5ZM12.9091 21.5H11.0909V22.5H12.9091V21.5ZM11.0909 21.5C6.34628 21.5 2.5 17.6537 2.5 12.9091H1.5C1.5 18.206 5.794 22.5 11.0909 22.5V21.5ZM21.5 12.9091C21.5 17.6537 17.6537 21.5 12.9091 21.5V22.5C18.206 22.5 22.5 18.206 22.5 12.9091H21.5ZM11.0909 1.5C8.3773 1.5 5.97353 3.08801 4.26909 5.26338C2.56315 7.44066 1.5 10.2744 1.5 12.9091H2.5C2.5 10.523 3.47192 7.9022 5.05624 5.88013C6.64207 3.85615 8.78375 2.5 11.0909 2.5V1.5Z"
          fill="#585858"
          className={"icon_fill"}
        />
      </svg>
    </>
  );
};

export const Frame = ({ ...props }) => {
  return (
    <>
      <svg
        onClick={props.onClick}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M22 3H2V21H22V3Z"
          stroke="#585858"
          className={"icon_stroke"}
          strokeLinejoin="round"
        />
        <path
          d="M19 6H5V18H19V6Z"
          stroke="#585858"
          className={"icon_stroke"}
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};

export const HalfFrame = ({ ...props }) => {
  return (
    <>
      <svg
        onClick={props.onClick}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M22 2H2V12V22L7.45455 16.5455V7.45455H15.6364L22 2Z"
          stroke="#585858"
          className={"icon_stroke"}
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};

export const LShape = ({ ...props }) => {
  return (
    <>
      <svg
        onClick={props.onClick}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.1818 2H2V12V22H22V9.27273H10.1818V2Z"
          stroke="#585858"
          className={"icon_stroke"}
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};

export const DiagonalStripe = ({ ...props }) => {
  return (
    <>
      <svg
        onClick={props.onClick}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 2L2 12V22L22 2H12Z"
          stroke="#585858"
          className={"icon_stroke"}
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};

export const Cross = ({ ...props }) => {
  return (
    <>
      <svg
        onClick={props.onClick}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M22 16.5455V12V7.45455H17V2H12H7V7.45455H2V12V16.5455H7V22H12H17V16.5455H22Z"
          stroke="#585858"
          className={"icon_stroke"}
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};

export const Plague = ({ ...props }) => {
  return (
    <>
      <svg
        onClick={props.onClick}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M22 16.5455V17.0455C22.2761 17.0455 22.5 16.8216 22.5 16.5455H22ZM17 22V22.5C17.2761 22.5 17.5 22.2761 17.5 22H17ZM7 22H6.5C6.5 22.2761 6.72386 22.5 7 22.5V22ZM2 16.5455H1.5C1.5 16.8216 1.72386 17.0455 2 17.0455V16.5455ZM2 7.45455V6.95455C1.72386 6.95455 1.5 7.1784 1.5 7.45455H2ZM7 2V1.5C6.72386 1.5 6.5 1.72386 6.5 2H7ZM17 2H17.5C17.5 1.72386 17.2761 1.5 17 1.5V2ZM22 7.45455H22.5C22.5 7.1784 22.2761 6.95455 22 6.95455V7.45455ZM16.5 21.5455V22H17.5V21.5455H16.5ZM7.5 22V21.5455H6.5V22H7.5ZM7.5 2.45454V2H6.5V2.45454H7.5ZM16.5 2V2.45454H17.5V2H16.5ZM7.5 21.5455C7.5 18.5079 5.03757 16.0455 2 16.0455V17.0455C4.48528 17.0455 6.5 19.0602 6.5 21.5455H7.5ZM22 16.0455C18.9624 16.0455 16.5 18.5079 16.5 21.5455H17.5C17.5 19.0602 19.5147 17.0455 22 17.0455V16.0455ZM16.5 2.45454C16.5 5.49211 18.9624 7.95455 22 7.95455V6.95455C19.5147 6.95455 17.5 4.93983 17.5 2.45454H16.5ZM2 7.95455C5.03757 7.95455 7.5 5.49211 7.5 2.45454H6.5C6.5 4.93983 4.48528 6.95455 2 6.95455V7.95455ZM21.5 7.45455V16.5455H22.5V7.45455H21.5ZM17 21.5H7V22.5H17V21.5ZM2.5 16.5455V7.45455H1.5V16.5455H2.5ZM7 2.5H17V1.5H7V2.5Z"
          fill="#585858"
          className={"icon_fill"}
        />
      </svg>
    </>
  );
};

export const Can = ({ ...props }) => {
  return (
    <>
      <svg
        onClick={props.onClick}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2 5L1.6746 4.62037C1.56378 4.71536 1.5 4.85404 1.5 5H2ZM22 5H22.5C22.5 4.85404 22.4362 4.71536 22.3254 4.62037L22 5ZM2 19H1.5C1.5 19.1326 1.55268 19.2598 1.64645 19.3536L2 19ZM22 19L22.3536 19.3536C22.4473 19.2598 22.5 19.1326 22.5 19H22ZM12 21.5C8.57402 21.5 6.14537 20.7664 4.58453 20.046C3.80314 19.6854 3.23691 19.327 2.87028 19.063C2.68693 18.931 2.55347 18.8226 2.46797 18.7493C2.42523 18.7126 2.39447 18.6848 2.37548 18.6672C2.36598 18.6583 2.35943 18.6521 2.35578 18.6486C2.35396 18.6468 2.35287 18.6458 2.3525 18.6454C2.35231 18.6452 2.35231 18.6452 2.35248 18.6454C2.35257 18.6455 2.3527 18.6456 2.35288 18.6458C2.35297 18.6459 2.35314 18.646 2.35318 18.6461C2.35336 18.6463 2.35355 18.6464 2 19C1.64645 19.3536 1.64666 19.3538 1.64688 19.354C1.64697 19.3541 1.64721 19.3543 1.64739 19.3545C1.64775 19.3549 1.64816 19.3553 1.64862 19.3557C1.64953 19.3566 1.65062 19.3577 1.65191 19.359C1.65447 19.3615 1.65779 19.3647 1.66186 19.3686C1.66999 19.3765 1.68113 19.3871 1.69532 19.4002C1.72369 19.4265 1.76423 19.4631 1.81718 19.5085C1.92309 19.5993 2.07869 19.7253 2.28597 19.8745C2.70059 20.173 3.32186 20.5646 4.16547 20.954C5.85463 21.7336 8.42598 22.5 12 22.5V21.5ZM2.5 19V5H1.5V19H2.5ZM21.5 5V19H22.5V5H21.5ZM22 19C21.6464 18.6464 21.6466 18.6463 21.6468 18.6461C21.6469 18.646 21.647 18.6459 21.6471 18.6458C21.6473 18.6456 21.6474 18.6455 21.6475 18.6454C21.6477 18.6452 21.6477 18.6452 21.6475 18.6454C21.6471 18.6458 21.646 18.6468 21.6442 18.6486C21.6406 18.6521 21.634 18.6583 21.6245 18.6672C21.6055 18.6848 21.5748 18.7126 21.532 18.7493C21.4465 18.8226 21.3131 18.931 21.1297 19.063C20.7631 19.327 20.1969 19.6854 19.4155 20.046C17.8546 20.7664 15.426 21.5 12 21.5V22.5C15.574 22.5 18.1454 21.7336 19.8345 20.954C20.6781 20.5646 21.2994 20.173 21.714 19.8745C21.9213 19.7253 22.0769 19.5993 22.1828 19.5085C22.2358 19.4631 22.2763 19.4265 22.3047 19.4002C22.3189 19.3871 22.33 19.3765 22.3381 19.3686C22.3422 19.3647 22.3455 19.3615 22.3481 19.359C22.3494 19.3577 22.3505 19.3566 22.3514 19.3557C22.3518 19.3553 22.3522 19.3549 22.3526 19.3545C22.3528 19.3543 22.353 19.3541 22.3531 19.354C22.3533 19.3538 22.3536 19.3536 22 19ZM2 5C2.3254 5.37963 2.32524 5.37976 2.3251 5.37989C2.32506 5.37991 2.32493 5.38002 2.32487 5.38007C2.32475 5.38018 2.32468 5.38024 2.32467 5.38025C2.32464 5.38028 2.32482 5.38012 2.32521 5.37979C2.32599 5.37913 2.32761 5.37777 2.33008 5.37572C2.33501 5.37161 2.3433 5.36477 2.35494 5.35538C2.37822 5.33658 2.41489 5.30758 2.46481 5.2698C2.56466 5.19423 2.71748 5.08364 2.92227 4.9496C3.33191 4.68147 3.94896 4.31984 4.76557 3.95691C6.39785 3.23145 8.8289 2.5 12 2.5V1.5C8.6711 1.5 6.10215 2.26855 4.35943 3.04309C3.48854 3.43016 2.82434 3.81853 2.37461 4.1129C2.14971 4.26011 1.97831 4.38389 1.86136 4.47239C1.80289 4.51664 1.75801 4.55209 1.72685 4.57724C1.71127 4.58982 1.69911 4.59982 1.6904 4.60707C1.68604 4.6107 1.68255 4.61363 1.67992 4.61586C1.6786 4.61697 1.6775 4.6179 1.67661 4.61866C1.67617 4.61903 1.67578 4.61937 1.67545 4.61965C1.67528 4.61979 1.67507 4.61997 1.67498 4.62005C1.67479 4.62021 1.6746 4.62037 2 5ZM12 2.5C15.1711 2.5 17.6022 3.23145 19.2344 3.95691C20.051 4.31984 20.6681 4.68147 21.0777 4.9496C21.2825 5.08364 21.4353 5.19423 21.5352 5.2698C21.5851 5.30758 21.6218 5.33658 21.6451 5.35538C21.6567 5.36477 21.665 5.37161 21.6699 5.37572C21.6724 5.37777 21.674 5.37913 21.6748 5.37979C21.6752 5.38012 21.6754 5.38028 21.6753 5.38025C21.6753 5.38024 21.6752 5.38018 21.6751 5.38007C21.6751 5.38002 21.6749 5.37991 21.6749 5.37989C21.6748 5.37976 21.6746 5.37963 22 5C22.3254 4.62037 22.3252 4.62021 22.325 4.62005C22.3249 4.61997 22.3247 4.61979 22.3246 4.61965C22.3242 4.61937 22.3238 4.61903 22.3234 4.61866C22.3225 4.6179 22.3214 4.61697 22.3201 4.61586C22.3175 4.61363 22.314 4.6107 22.3096 4.60707C22.3009 4.59982 22.2887 4.58982 22.2732 4.57724C22.242 4.55209 22.1971 4.51664 22.1386 4.47239C22.0217 4.38389 21.8503 4.26011 21.6254 4.1129C21.1757 3.81853 20.5115 3.43016 19.6406 3.04309C17.8978 2.26855 15.3289 1.5 12 1.5V2.5ZM2 5C1.6746 5.37963 1.67479 5.37979 1.67498 5.37995C1.67507 5.38003 1.67528 5.38021 1.67545 5.38035C1.67578 5.38063 1.67617 5.38097 1.67661 5.38134C1.6775 5.3821 1.6786 5.38303 1.67992 5.38414C1.68255 5.38637 1.68604 5.3893 1.6904 5.39293C1.69911 5.40018 1.71127 5.41018 1.72685 5.42276C1.75801 5.44791 1.80289 5.48336 1.86136 5.52761C1.97831 5.61611 2.14971 5.73989 2.37461 5.8871C2.82434 6.18147 3.48854 6.56984 4.35943 6.95691C6.10215 7.73145 8.6711 8.5 12 8.5V7.5C8.8289 7.5 6.39785 6.76855 4.76557 6.04309C3.94896 5.68016 3.33191 5.31853 2.92227 5.0504C2.71748 4.91636 2.56466 4.80577 2.46481 4.7302C2.41489 4.69242 2.37822 4.66342 2.35494 4.64462C2.3433 4.63523 2.33501 4.62839 2.33008 4.62428C2.32761 4.62223 2.32599 4.62087 2.32521 4.62021C2.32482 4.61988 2.32464 4.61972 2.32467 4.61975C2.32468 4.61976 2.32475 4.61982 2.32487 4.61993C2.32493 4.61998 2.32506 4.62009 2.3251 4.62011C2.32524 4.62024 2.3254 4.62037 2 5ZM12 8.5C15.3289 8.5 17.8978 7.73145 19.6406 6.95691C20.5115 6.56984 21.1757 6.18147 21.6254 5.8871C21.8503 5.73989 22.0217 5.61611 22.1386 5.52761C22.1971 5.48336 22.242 5.44791 22.2732 5.42276C22.2887 5.41018 22.3009 5.40018 22.3096 5.39293C22.314 5.3893 22.3175 5.38637 22.3201 5.38414C22.3214 5.38303 22.3225 5.3821 22.3234 5.38134C22.3238 5.38097 22.3242 5.38063 22.3246 5.38035C22.3247 5.38021 22.3249 5.38003 22.325 5.37995C22.3252 5.37979 22.3254 5.37963 22 5C21.6746 4.62037 21.6748 4.62024 21.6749 4.62011C21.6749 4.62009 21.6751 4.61998 21.6751 4.61993C21.6752 4.61982 21.6753 4.61976 21.6753 4.61975C21.6754 4.61972 21.6752 4.61988 21.6748 4.62021C21.674 4.62087 21.6724 4.62223 21.6699 4.62428C21.665 4.62839 21.6567 4.63523 21.6451 4.64462C21.6218 4.66342 21.5851 4.69242 21.5352 4.7302C21.4353 4.80577 21.2825 4.91636 21.0777 5.0504C20.6681 5.31853 20.051 5.68016 19.2344 6.04309C17.6022 6.76855 15.1711 7.5 12 7.5V8.5Z"
          fill="#585858"
          className={"icon_fill"}
        />
      </svg>
    </>
  );
};

export const Cube = ({ ...props }) => {
  return (
    <>
      <svg
        onClick={props.onClick}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2 6L6.5 2H22M2 6H18M2 6V22H18M22 2V11V16L18 22M22 2L18 6M18 22V6"
          stroke="#585858"
          className={"icon_stroke"}
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};

export const Donut = ({ ...props }) => {
  return (
    <>
      <svg
        onClick={props.onClick}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.5 12C2.5 6.75329 6.75329 2.5 12 2.5C17.2467 2.5 21.5 6.75329 21.5 12C21.5 17.2467 17.2467 21.5 12 21.5C6.75329 21.5 2.5 17.2467 2.5 12ZM12 1.5C6.20101 1.5 1.5 6.20101 1.5 12C1.5 17.799 6.20101 22.5 12 22.5C17.799 22.5 22.5 17.799 22.5 12C22.5 6.20101 17.799 1.5 12 1.5ZM7.5 12C7.5 9.51472 9.51472 7.5 12 7.5C14.4853 7.5 16.5 9.51472 16.5 12C16.5 14.4853 14.4853 16.5 12 16.5C9.51472 16.5 7.5 14.4853 7.5 12ZM12 6.5C8.96243 6.5 6.5 8.96243 6.5 12C6.5 15.0376 8.96243 17.5 12 17.5C15.0376 17.5 17.5 15.0376 17.5 12C17.5 8.96243 15.0376 6.5 12 6.5Z"
          fill="#585858"
          className={"icon_fill"}
        />
      </svg>
    </>
  );
};

export const NoSymbol = ({ ...props }) => {
  return (
    <>
      <svg
        onClick={props.onClick}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.5 12C2.5 6.75329 6.75329 2.5 12 2.5C17.2467 2.5 21.5 6.75329 21.5 12C21.5 17.2467 17.2467 21.5 12 21.5C6.75329 21.5 2.5 17.2467 2.5 12ZM12 1.5C6.20101 1.5 1.5 6.20101 1.5 12C1.5 17.799 6.20101 22.5 12 22.5C17.799 22.5 22.5 17.799 22.5 12C22.5 6.20101 17.799 1.5 12 1.5ZM18.1918 13.9839L8.64577 6.43109C9.62486 5.83999 10.7722 5.5 12 5.5C15.5899 5.5 18.5 8.41015 18.5 12C18.5 12.6924 18.3919 13.3589 18.1918 13.9839ZM12 4.5C10.3122 4.5 8.75325 5.05814 7.49971 5.9997L6.98116 6.3892L7.48976 6.7916L18.1073 15.1921L18.616 15.5946L18.8757 15.0002C19.2774 14.0808 19.5 13.0657 19.5 12C19.5 7.85786 16.1421 4.5 12 4.5ZM5.8927 8.80789L5.38399 8.4054L5.12428 8.99981C4.72259 9.9192 4.5 10.9343 4.5 12C4.5 16.1421 7.85786 19.5 12 19.5C13.6878 19.5 15.2468 18.9419 16.5003 18.0003L17.0188 17.6108L16.5102 17.2084L5.8927 8.80789ZM5.5 12C5.5 11.3076 5.60811 10.6411 5.80817 10.0161L15.3542 17.5689C14.3751 18.16 13.2278 18.5 12 18.5C8.41015 18.5 5.5 15.5899 5.5 12Z"
          fill="#585858"
          className={"icon_fill"}
        />
      </svg>
    </>
  );
};

export const BlockArc = ({ ...props }) => {
  return (
    <>
      <svg
        onClick={props.onClick}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M22 12C22 10.6868 21.7413 9.38642 21.2388 8.17317C20.7362 6.95991 19.9997 5.85752 19.0711 4.92893C18.1425 4.00035 17.0401 3.26375 15.8268 2.7612C14.6136 2.25866 13.3132 2 12 2C10.6868 2 9.38642 2.25866 8.17317 2.7612C6.95991 3.26375 5.85752 4.00035 4.92893 4.92893C4.00035 5.85752 3.26375 6.95991 2.7612 8.17317C2.25866 9.38642 2 10.6868 2 12L7 12C7 11.3434 7.12933 10.6932 7.3806 10.0866C7.63188 9.47996 8.00017 8.92876 8.46447 8.46447C8.92876 8.00017 9.47995 7.63188 10.0866 7.3806C10.6932 7.12933 11.3434 7 12 7C12.6566 7 13.3068 7.12933 13.9134 7.3806C14.52 7.63188 15.0712 8.00017 15.5355 8.46447C15.9998 8.92876 16.3681 9.47995 16.6194 10.0866C16.8707 10.6932 17 11.3434 17 12H22Z"
          stroke="#585858"
          className={"icon_stroke"}
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};

export const FoldedCorner = ({ ...props }) => {
  return (
    <>
      <svg
        onClick={props.onClick}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M14 22H3V2H21V15M14 22V15H21M14 22L21 15"
          stroke="#585858"
          className={"icon_stroke"}
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};

export const Smiley = ({ ...props }) => {
  return (
    <>
      <svg
        onClick={props.onClick}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.5 12C2.5 6.75329 6.75329 2.5 12 2.5C17.2467 2.5 21.5 6.75329 21.5 12C21.5 17.2467 17.2467 21.5 12 21.5C6.75329 21.5 2.5 17.2467 2.5 12ZM12 1.5C6.20101 1.5 1.5 6.20101 1.5 12C1.5 17.799 6.20101 22.5 12 22.5C17.799 22.5 22.5 17.799 22.5 12C22.5 6.20101 17.799 1.5 12 1.5ZM7.67499 13.963C7.57905 13.704 7.29137 13.5719 7.03243 13.6678C6.77348 13.7638 6.64134 14.0514 6.73728 14.3104C7.08696 15.2542 7.79775 16.0605 8.73802 16.6259C9.678 17.1912 10.8091 17.4939 11.9649 17.4999C13.1206 17.5059 14.2562 17.215 15.2046 16.6599C16.1533 16.1048 16.8764 15.3067 17.2411 14.3674C17.341 14.11 17.2134 13.8203 16.9559 13.7204C16.6985 13.6204 16.4088 13.7481 16.3089 14.0055C16.0373 14.7051 15.4822 15.3388 14.6995 15.7969C13.9166 16.255 12.9594 16.5051 11.9701 16.4999C10.9807 16.4948 10.0281 16.2348 9.25336 15.7689C8.4789 15.3032 7.93489 14.6645 7.67499 13.963ZM7.5 9.5C7.5 8.94772 7.94772 8.5 8.5 8.5C9.05228 8.5 9.5 8.94772 9.5 9.5C9.5 10.0523 9.05228 10.5 8.5 10.5C7.94772 10.5 7.5 10.0523 7.5 9.5ZM15.5 8.5C14.9477 8.5 14.5 8.94772 14.5 9.5C14.5 10.0523 14.9477 10.5 15.5 10.5C16.0523 10.5 16.5 10.0523 16.5 9.5C16.5 8.94772 16.0523 8.5 15.5 8.5Z"
          fill="#585858"
          className={"icon_fill"}
        />
      </svg>
    </>
  );
};

export const Heart = ({ ...props }) => {
  return (
    <>
      <svg
        onClick={props.onClick}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12.0063 21L3.51888 12.709C-1.09384 7.73443 5.68686 -1.81677 12.0063 5.91042C18.3257 -1.81677 25.0757 7.7676 20.4937 12.709L12.0063 21Z"
          stroke="#585858"
          className={"icon_stroke"}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};

export const Bolt = ({ ...props }) => {
  return (
    <>
      <svg
        onClick={props.onClick}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.64886 2L4.05983 10.1692C4.01019 10.2858 3.99099 10.4123 4.00391 10.5377C4.01684 10.663 4.06149 10.7834 4.13395 10.8882C4.20641 10.9931 4.30446 11.0791 4.41948 11.1389C4.53449 11.1986 4.66296 11.2301 4.79359 11.2308H9.24398L6.05374 22L19.7558 9.47692C19.8697 9.37115 19.9483 9.23514 19.9819 9.08616C20.0154 8.93718 20.0023 8.78196 19.9441 8.64019C19.886 8.49842 19.7856 8.3765 19.6555 8.28991C19.5254 8.20332 19.3715 8.15596 19.2135 8.15385L13.2318 8.15385L16.422 2L7.64886 2Z"
          stroke="#585858"
          className={"icon_stroke"}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};

export const Sun = ({ ...props }) => {
  return (
    <>
      <svg
        onClick={props.onClick}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.998 1C12.2742 1 12.498 1.22386 12.498 1.5V4.73008C12.498 5.00623 12.2742 5.23008 11.998 5.23008C11.7219 5.23008 11.498 5.00623 11.498 4.73008V1.5C11.498 1.22386 11.7219 1 11.998 1ZM11.9986 8.46026C10.0448 8.46026 8.461 10.0441 8.461 11.9979C8.461 13.9516 10.0448 15.5355 11.9986 15.5355C13.9523 15.5355 15.5361 13.9516 15.5361 11.9979C15.5361 10.0441 13.9523 8.46026 11.9986 8.46026ZM7.461 11.9979C7.461 9.49182 9.49253 7.46026 11.9986 7.46026C14.5046 7.46026 16.5361 9.49182 16.5361 11.9979C16.5361 14.5039 14.5046 16.5355 11.9986 16.5355C9.49253 16.5355 7.461 14.5039 7.461 11.9979ZM4.92094 4.21505C4.72568 4.01979 4.40909 4.01979 4.21383 4.21505C4.01857 4.41031 4.01857 4.72689 4.21383 4.92215L6.50796 7.21632C6.70322 7.41158 7.0198 7.41158 7.21507 7.21632C7.41033 7.02106 7.41033 6.70448 7.21507 6.50921L4.92094 4.21505ZM1 11.9977C1 11.7215 1.22386 11.4977 1.5 11.4977H4.73004C5.00619 11.4977 5.23004 11.7215 5.23004 11.9977C5.23004 12.2738 5.00619 12.4977 4.73004 12.4977H1.5C1.22386 12.4977 1 12.2738 1 11.9977ZM7.21507 17.4871C7.41033 17.2918 7.41033 16.9753 7.21507 16.78C7.0198 16.5847 6.70322 16.5847 6.50796 16.78L4.21383 19.0742C4.01857 19.2694 4.01857 19.586 4.21383 19.7813C4.40909 19.9765 4.72568 19.9765 4.92094 19.7813L7.21507 17.4871ZM11.998 18.7654C12.2742 18.7654 12.498 18.9892 12.498 19.2654V22.4955C12.498 22.7716 12.2742 22.9955 11.998 22.9955C11.7219 22.9955 11.498 22.7716 11.498 22.4955V19.2654C11.498 18.9892 11.7219 18.7654 11.998 18.7654ZM17.4883 16.78C17.2931 16.5847 16.9765 16.5847 16.7812 16.78C16.586 16.9753 16.5859 17.2918 16.7812 17.4871L19.0753 19.7813C19.2706 19.9765 19.5872 19.9765 19.7825 19.7813C19.9777 19.586 19.9777 19.2694 19.7825 19.0742L17.4883 16.78ZM18.7656 11.9976C18.7656 11.7214 18.9895 11.4976 19.2656 11.4976H22.4957C22.7718 11.4976 22.9957 11.7214 22.9957 11.9976C22.9957 12.2737 22.7718 12.4976 22.4957 12.4976H19.2656C18.9895 12.4976 18.7656 12.2737 18.7656 11.9976ZM19.7825 4.92215C19.9777 4.72689 19.9777 4.41031 19.7825 4.21505C19.5872 4.01979 19.2706 4.01979 19.0753 4.21505L16.7812 6.50921C16.5859 6.70448 16.586 7.02106 16.7812 7.21632C16.9765 7.41158 17.2931 7.41158 17.4883 7.21632L19.7825 4.92215Z"
          fill="#585858"
          className={"icon_fill"}
        />
      </svg>
    </>
  );
};

export const Moon = ({ ...props }) => {
  return (
    <>
      <svg
        onClick={props.onClick}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.5842 12C13.5915 10.1348 14.0902 8.30348 15.0314 6.68536C15.9725 5.06723 17.3239 3.71781 18.9532 2.76923C17.745 2.27618 16.4524 2.01509 15.1449 2C12.4543 2 9.87392 3.05357 7.97138 4.92893C6.06884 6.8043 5 9.34784 5 12C5 14.6522 6.06884 17.1957 7.97138 19.0711C9.87392 20.9464 12.4543 22 15.1449 22C16.4682 21.9908 17.7773 21.7296 19 21.2308C17.362 20.2879 16.0013 18.941 15.0517 17.3225C14.1021 15.704 13.5963 13.8697 13.5842 12V12Z"
          stroke="#585858"
          className={"icon_stroke"}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};

export const Cloud = ({ ...props }) => {
  return (
    <>
      <svg
        onClick={props.onClick}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18.3059 10.0248C18.0534 10.0028 17.799 10.0028 17.5465 10.0248C17.269 8.88399 16.5677 7.86303 15.559 7.13104C14.5502 6.39906 13.2945 6 12 6C10.7055 6 9.44978 6.39906 8.44104 7.13104C7.43229 7.86303 6.73103 8.88399 6.45348 10.0248C6.20094 10.0028 5.94667 10.0028 5.69412 10.0248C5.09153 9.99151 4.48778 10.0699 3.92001 10.2551C3.35224 10.4402 2.8325 10.7283 2.39277 11.1015C1.95304 11.4747 1.60262 11.9251 1.36309 12.4251C1.12357 12.9251 1 13.464 1 14.0087C1 14.5533 1.12357 15.0922 1.36309 15.5922C1.60262 16.0922 1.95304 16.5427 2.39277 16.9158C2.8325 17.289 3.35224 17.5771 3.92001 17.7623C4.48778 17.9475 5.09153 18.0258 5.69412 17.9925H18.3059C18.9085 18.0258 19.5122 17.9475 20.0799 17.7623C20.6477 17.5771 21.1676 17.289 21.6072 16.9158C22.0469 16.5427 22.3974 16.0922 22.6368 15.5922C22.8765 15.0922 23 14.5533 23 14.0087C23 13.464 22.8765 12.9251 22.6368 12.4251C22.3974 11.9251 22.0469 11.4747 21.6072 11.1015C21.1676 10.7283 20.6477 10.4402 20.0799 10.2551C19.5122 10.0699 18.9085 9.99151 18.3059 10.0248Z"
          stroke="#585858"
          className={"icon_stroke"}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};

export const FlowchartDecision = ({ ...props }) => {
  return (
    <>
      <svg
        onClick={props.onClick}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M22 12.2593L12 5L2 12.2593L12 19L22 12.2593Z"
          stroke="#585858"
          className={"icon_stroke"}
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};

export const FlowchartPredifinedProcess = ({ ...props }) => {
  return (
    <>
      <svg
        onClick={props.onClick}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5 3H2V21H5M5 3V21M5 3H19M5 21H19M19 3H22V21H19M19 3V21"
          stroke="#585858"
          className={"icon_stroke"}
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};

export const InternalStorage = ({ ...props }) => {
  return (
    <>
      <svg
        onClick={props.onClick}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M5 3H2V6M5 3V21M5 3H19H22V6M5 21H2V6M5 21H19H22V6M2 6H22"
          stroke="#585858"
          className={"icon_stroke"}
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};

export const FlowchartDocument = ({ ...props }) => {
  return (
    <>
      <svg
        onClick={props.onClick}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M2 2V1.5C1.72386 1.5 1.5 1.72386 1.5 2H2ZM22 2H22.5C22.5 1.72386 22.2761 1.5 22 1.5V2ZM22 18L21.7227 18.416C21.8761 18.5183 22.0734 18.5278 22.2359 18.4408C22.3985 18.3538 22.5 18.1844 22.5 18H22ZM2 20H1.5C1.5 20.2045 1.62448 20.3883 1.8143 20.4642L2 20ZM20.8282 17.2188L20.5509 17.6348L20.8282 17.2188ZM7.43768 21.7082L7.71503 22.1242L7.43768 21.7082ZM2 2.5H22V1.5H2V2.5ZM21.5 2V18H22.5V2H21.5ZM2.5 20V2H1.5V20H2.5ZM6.69729 21.3404L2.1857 19.5358L1.8143 20.4642L6.3259 22.2689L6.69729 21.3404ZM22.2773 17.584L21.1056 16.8028L20.5509 17.6348L21.7227 18.416L22.2773 17.584ZM13.8944 16.8028L7.16033 21.2922L7.71503 22.1242L14.4491 17.6348L13.8944 16.8028ZM21.1056 16.8028C18.9222 15.3472 16.0778 15.3472 13.8944 16.8028L14.4491 17.6348C16.2966 16.4032 18.7034 16.4032 20.5509 17.6348L21.1056 16.8028ZM6.3259 22.2689C6.78451 22.4523 7.30405 22.3982 7.71503 22.1242L7.16033 21.2922C7.02334 21.3835 6.85016 21.4015 6.69729 21.3404L6.3259 22.2689Z"
          fill="#585858"
          className={"icon_fill"}
        />
      </svg>
    </>
  );
};

export const MultipleDocuments = ({ ...props }) => {
  return (
    <>
      <svg
        onClick={props.onClick}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.83318 2C8.55704 2 8.33318 2.22386 8.33318 2.5V4.11084H6.7231C6.44696 4.11084 6.2231 4.3347 6.2231 4.61084V6.22168H4.61204C4.3359 6.22168 4.11204 6.44554 4.11204 6.72168V8.33228H2.50098C2.22483 8.33228 2.00098 8.55613 2.00098 8.83228V17.6426C2.00098 17.8171 2.09195 17.979 2.24101 18.0697L8.57357 21.9243C8.73326 22.0215 8.93383 22.0215 9.09351 21.9243L15.4261 18.0697C15.5751 17.979 15.6661 17.8171 15.6661 17.6426V16.7204H17.2772C17.5533 16.7204 17.7772 16.4965 17.7772 16.2204V14.6095H19.3882C19.6644 14.6095 19.8882 14.3857 19.8882 14.1095V12.4987H21.4983C21.7745 12.4987 21.9983 12.2748 21.9983 11.9987V2.5C21.9983 2.22386 21.7745 2 21.4983 2H8.83318ZM19.8882 11.4987H20.9983V3H9.33318V4.11084H19.3882C19.6644 4.11084 19.8882 4.3347 19.8882 4.61084V11.4987ZM18.8882 13.6095H17.7772V6.72168C17.7772 6.44554 17.5533 6.22168 17.2772 6.22168H7.2231V5.11084H18.8882V13.6095ZM15.6661 15.7204H16.7772V7.22168H5.11204V8.33228H15.1661C15.4423 8.33228 15.6661 8.55613 15.6661 8.83228V15.7204ZM3.00098 17.3616V9.33228H14.6661V17.3616L8.83354 20.9118L3.00098 17.3616Z"
          fill="#585858"
          className={"icon_fill"}
        />
      </svg>
    </>
  );
};

export const FlowchartTerminator = ({ ...props }) => {
  return (
    <>
      <svg
        onClick={props.onClick}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M18 7H6C3.79086 7 2 8.79086 2 11V13C2 15.2091 3.79086 17 6 17H18C20.2091 17 22 15.2091 22 13V11C22 8.79086 20.2091 7 18 7Z"
          stroke="#585858"
          className={"icon_stroke"}
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};

export const FlowchartPreparation = ({ ...props }) => {
  return (
    <>
      <svg
        onClick={props.onClick}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.45455 18H16.5455L22 12L16.5455 6H7.45455L2 12L7.45455 18Z"
          stroke="#585858"
          className={"icon_stroke"}
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};

export const ManualInput = ({ ...props }) => {
  return (
    <>
      <svg
        onClick={props.onClick}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M22 3L2 12.4118V19H22V3Z"
          stroke="#585858"
          className={"icon_stroke"}
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};

export const ManualOperation = ({ ...props }) => {
  return (
    <>
      <svg
        onClick={props.onClick}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M20 3H4L6.26087 19H17.7391L20 3Z"
          stroke="#585858"
          className={"icon_stroke"}
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};

export const FlowchartConnector = ({ ...props }) => {
  return (
    <>
      <svg
        onClick={props.onClick}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="12" cy="12" r="8" stroke="#585858" className={"icon_stroke"} />
      </svg>
    </>
  );
};

export const FlowchartOffPageConnector = ({ ...props }) => {
  return (
    <>
      <svg
        onClick={props.onClick}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.5 3C2.5 2.72386 2.72386 2.5 3 2.5H21C21.2761 2.5 21.5 2.72386 21.5 3V15.5217C21.5 15.6962 21.409 15.8581 21.26 15.9488L12.26 21.4271C12.1003 21.5243 11.8997 21.5243 11.74 21.4271L2.74003 15.9488C2.59097 15.8581 2.5 15.6962 2.5 15.5217V3ZM3.5 3.5V15.2407L12 20.4147L20.5 15.2407V3.5H3.5Z"
          fill="#585858"
          className={"icon_fill"}
        />
      </svg>
    </>
  );
};

export const FlowchartCard = ({ ...props }) => {
  return (
    <>
      <svg
        onClick={props.onClick}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M10.1588 2.63447C10.2514 2.54806 10.3734 2.5 10.5 2.5H21C21.2761 2.5 21.5 2.72386 21.5 3V21C21.5 21.2761 21.2761 21.5 21 21.5H3C2.72386 21.5 2.5 21.2761 2.5 21V10C2.5 9.86141 2.55752 9.72904 2.65884 9.63447L10.1588 2.63447ZM10.6971 3.5L3.5 10.2173V20.5H20.5V3.5H10.6971Z"
          fill="#585858"
          className={"icon_fill"}
        />
      </svg>
    </>
  );
};

export const FlowchartTape = ({ ...props }) => {
  return (
    <>
      <svg
        onClick={props.onClick}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.2092 4.83566C10.7072 5.59862 9.06955 6.40566 6.90875 6.00459C6.03343 5.84212 4.99238 5.45254 4.19156 5.11643C3.93609 5.0092 3.70151 4.90588 3.5 4.81465V18.6273C3.54543 18.6569 3.59731 18.6904 3.65498 18.7272C3.89167 18.8782 4.22466 19.0836 4.60905 19.3011C5.38976 19.7427 6.33822 20.208 7.11484 20.3913C8.88509 20.809 10.21 19.963 11.7226 18.904C11.785 18.8603 11.8477 18.8162 11.9108 18.7719C13.3248 17.7784 14.9327 16.6485 17.0615 16.9122C18.0494 17.0346 19.1031 17.4302 19.8888 17.78C20.1139 17.8802 20.32 17.978 20.5 18.0668V4.388C20.4833 4.38265 20.4661 4.37714 20.4483 4.37148C20.2023 4.29307 19.8577 4.18674 19.4641 4.07526C18.6692 3.85009 17.7032 3.61227 16.9472 3.53198C15.15 3.3411 13.7862 4.03424 12.2973 4.79092C12.268 4.80581 12.2386 4.82073 12.2092 4.83566ZM21 4.02606L21.1619 3.55301C21.3641 3.62223 21.5 3.81233 21.5 4.02606V18.8953C21.5 19.0742 21.4045 19.2394 21.2495 19.3286C21.0946 19.4178 20.9038 19.4175 20.7492 19.3279L20.7491 19.3278C20.7491 19.3278 20.7491 19.3278 20.7491 19.3278C20.7491 19.3278 20.7491 19.3278 20.749 19.3278L20.7484 19.3274L20.7447 19.3253L20.7283 19.3159C20.7133 19.3074 20.6906 19.2946 20.6607 19.278C20.6008 19.2448 20.5122 19.1966 20.3999 19.1377C20.175 19.0198 19.8561 18.8601 19.4821 18.6936C18.7248 18.3564 17.7785 18.0087 16.9385 17.9046C15.1994 17.6892 13.8861 18.6093 12.392 19.656C12.3601 19.6783 12.3282 19.7007 12.2962 19.7231C10.815 20.7601 9.13996 21.8966 6.88516 21.3645C5.96279 21.1469 4.91124 20.6209 4.1167 20.1715C3.71347 19.9434 3.36502 19.7284 3.11718 19.5703C2.99313 19.4911 2.89397 19.4261 2.82539 19.3805C2.79109 19.3577 2.76442 19.3397 2.74609 19.3273L2.72492 19.3129L2.71918 19.309L2.71756 19.3079L2.71706 19.3076L2.71689 19.3075C2.71683 19.3074 2.71677 19.3074 3 18.8953L2.71677 19.3074C2.58107 19.2141 2.5 19.06 2.5 18.8953V4.02606C2.5 3.8527 2.5898 3.69171 2.73731 3.60063C2.88481 3.50956 3.06895 3.50138 3.22393 3.57901L3.22394 3.57901L3.22398 3.57904L3.2241 3.5791L3.22508 3.57958L3.22955 3.58181L3.24832 3.59112C3.26512 3.59941 3.29033 3.6118 3.32322 3.62779C3.38901 3.65977 3.48541 3.7061 3.60645 3.76279C3.84873 3.87625 4.18867 4.0307 4.57857 4.19435C5.3678 4.5256 6.32675 4.87949 7.09125 5.02139C8.88712 5.35472 10.2483 4.7101 11.7564 3.94408C11.8071 3.91834 11.8579 3.89245 11.909 3.86646C13.3556 3.13007 14.9568 2.31496 17.0528 2.53757C17.8978 2.62732 18.9319 2.88515 19.7366 3.11311C20.1429 3.22819 20.4981 3.3378 20.752 3.41869C20.879 3.45917 20.9808 3.49251 21.0512 3.51585L21.1324 3.54301L21.1539 3.55029L21.1597 3.55224L21.1612 3.55277L21.1617 3.55293L21.1618 3.55298L21 4.02606Z"
          fill="#585858"
          className={"icon_fill"}
        />
      </svg>
    </>
  );
};

export const FlowchartSummingJunction = ({ ...props }) => {
  return (
    <>
      <svg
        onClick={props.onClick}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4.5 5.38544C2.94409 7.14827 2 9.46388 2 12C2 14.7974 3.14864 17.3265 5 19.1414M4.5 5.38544C6.33236 3.30939 9.01327 2 12 2C14.9867 2 17.6676 3.30939 19.5 5.38544M4.5 5.38544L19 19.1414M19 19.1414C20.8514 17.3265 22 14.7974 22 12C22 9.46388 21.0559 7.14827 19.5 5.38544M19 19.1414C17.1962 20.9097 14.7255 22 12 22C9.27455 22 6.80375 20.9097 5 19.1414M19.5 5.38544L5 19.1414"
          stroke="#585858"
          className={"icon_stroke"}
        />
      </svg>
    </>
  );
};

export const FlowchartOr = ({ ...props }) => {
  return (
    <>
      <svg
        onClick={props.onClick}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M22 12C22 17.5228 17.5228 22 12 22M22 12C22 6.47715 17.5228 2 12 2M22 12H2M12 22C6.47715 22 2 17.5228 2 12M12 22V2M2 12C2 6.47715 6.47715 2 12 2"
          stroke="#585858"
          className={"icon_stroke"}
        />
      </svg>
    </>
  );
};

export const FlowchartCollate = ({ ...props }) => {
  return (
    <>
      <svg
        onClick={props.onClick}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.53806 2.80866C2.61545 2.62182 2.79777 2.5 3 2.5H21C21.2022 2.5 21.3846 2.62182 21.4619 2.80866C21.5393 2.9955 21.4966 3.21055 21.3536 3.35355L12.7071 12L21.3536 20.6464C21.4966 20.7894 21.5393 21.0045 21.4619 21.1913C21.3846 21.3782 21.2022 21.5 21 21.5H12H3C2.79777 21.5 2.61545 21.3782 2.53806 21.1913C2.46067 21.0045 2.50345 20.7894 2.64645 20.6464L11.2929 12L2.64645 3.35355C2.50345 3.21055 2.46067 2.9955 2.53806 2.80866ZM12 11.2929L19.7929 3.5H4.20711L12 11.2929ZM12 12.7071L4.20711 20.5H12H19.7929L12 12.7071Z"
          fill="#585858"
          className={"icon_fill"}
        />
      </svg>
    </>
  );
};

export const FlowchartSort = ({ ...props }) => {
  return (
    <>
      <svg
        onClick={props.onClick}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.0003 1.5C12.1421 1.5 12.2772 1.56016 12.372 1.66552L21.372 11.6655C21.5431 11.8557 21.5431 12.1443 21.372 12.3345L12.372 22.3345C12.2772 22.4398 12.1421 22.5 12.0003 22.5C11.8586 22.5 11.7235 22.4398 11.6287 22.3345L2.62836 12.3345C2.45721 12.1443 2.45721 11.8557 2.62836 11.6655L11.6287 1.66551C11.7235 1.56016 11.8586 1.5 12.0003 1.5ZM4.12271 12.5L12.0003 21.2526L19.8777 12.5H4.12271ZM19.8777 11.5H4.12271L12.0003 2.74742L19.8777 11.5Z"
          fill="#585858"
          className={"icon_fill"}
        />
      </svg>
    </>
  );
};

export const FlowchartExtract = ({ ...props }) => {
  return (
    <>
      <svg
        onClick={props.onClick}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M22 21L2 21L12 3L22 21Z"
          stroke="#585858"
          className={"icon_stroke"}
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};

export const FlowchartMerge = ({ ...props }) => {
  return (
    <>
      <svg
        onClick={props.onClick}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 21L2 3L22 3L12 21Z"
          stroke="#585858"
          className={"icon_stroke"}
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};

export const FlowchartStoredData = ({ ...props }) => {
  return (
    <>
      <svg
        onClick={props.onClick}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M20 3L20.3723 3.33373C20.504 3.18684 20.537 2.97625 20.4565 2.79612C20.3761 2.61599 20.1973 2.5 20 2.5L20 3ZM20 21L20 21.5C20.1973 21.5 20.3761 21.384 20.4565 21.2039C20.537 21.0238 20.504 20.8132 20.3723 20.6663L20 21ZM6.82353 3L6.82353 2.5C6.69479 2.5 6.57101 2.54966 6.47797 2.63863L6.82353 3ZM6.82353 21L6.47797 21.3614C6.57101 21.4503 6.69479 21.5 6.82353 21.5L6.82353 21ZM4.5 12C4.5 8.92764 5.18784 6.75173 5.86206 5.35484C6.19968 4.65532 6.53509 4.14871 6.78179 3.82106C6.90515 3.65722 7.00634 3.53812 7.07453 3.46205C7.10862 3.42402 7.13445 3.39675 7.15066 3.38004C7.15877 3.37169 7.16447 3.36597 7.1676 3.36287C7.16917 3.36131 7.17009 3.36042 7.17034 3.36017C7.17047 3.36004 7.17043 3.36008 7.17022 3.36028C7.17012 3.36038 7.16997 3.36052 7.16978 3.3607C7.16969 3.36079 7.16952 3.36096 7.16947 3.36101C7.16928 3.36118 7.16909 3.36137 6.82353 3C6.47797 2.63863 6.47775 2.63884 6.47753 2.63905C6.47744 2.63914 6.4772 2.63937 6.47702 2.63954C6.47666 2.63989 6.47625 2.64028 6.47581 2.64071C6.47492 2.64157 6.47385 2.6426 6.47262 2.64379C6.47017 2.64619 6.46704 2.64926 6.46326 2.65301C6.4557 2.66051 6.44555 2.67072 6.43297 2.68368C6.40783 2.70959 6.373 2.74649 6.32989 2.79459C6.24366 2.89078 6.12426 3.03184 5.98292 3.21956C5.7002 3.59504 5.32973 4.15718 4.96147 4.92016C4.22392 6.44827 3.5 8.77236 3.5 12L4.5 12ZM6.82353 3.5L20 3.5L20 2.5L6.82353 2.5L6.82353 3.5ZM20 20.5L6.82353 20.5L6.82353 21.5L20 21.5L20 20.5ZM6.82353 21C7.16909 20.6386 7.16928 20.6388 7.16947 20.639C7.16951 20.639 7.16969 20.6392 7.16978 20.6393C7.16997 20.6395 7.17012 20.6396 7.17022 20.6397C7.17043 20.6399 7.17047 20.64 7.17034 20.6398C7.17009 20.6396 7.16917 20.6387 7.1676 20.6371C7.16447 20.634 7.15877 20.6283 7.15066 20.62C7.13445 20.6032 7.10862 20.576 7.07453 20.5379C7.00634 20.4619 6.90515 20.3428 6.78179 20.1789C6.53509 19.8513 6.19968 19.3447 5.86206 18.6452C5.18784 17.2483 4.5 15.0724 4.5 12L3.5 12C3.5 15.2276 4.22392 17.5517 4.96147 19.0798C5.32973 19.8428 5.7002 20.405 5.98292 20.7804C6.12426 20.9682 6.24366 21.1092 6.32988 21.2054C6.373 21.2535 6.40783 21.2904 6.43297 21.3163C6.44555 21.3293 6.4557 21.3395 6.46326 21.347C6.46703 21.3507 6.47016 21.3538 6.47262 21.3562C6.47385 21.3574 6.47491 21.3584 6.47581 21.3593C6.47625 21.3597 6.47666 21.3601 6.47702 21.3605C6.4772 21.3606 6.47743 21.3609 6.47752 21.3609C6.47775 21.3612 6.47797 21.3614 6.82353 21ZM20 3C19.6277 2.66627 19.6275 2.66645 19.6273 2.66664C19.6273 2.66672 19.6271 2.66692 19.6269 2.66708C19.6267 2.66741 19.6263 2.66778 19.626 2.66819C19.6252 2.66903 19.6243 2.67006 19.6232 2.67129C19.6211 2.67374 19.6182 2.67697 19.6147 2.68097C19.6078 2.68898 19.5982 2.70009 19.5862 2.71429C19.5622 2.74269 19.5286 2.78346 19.4866 2.8365C19.4027 2.94255 19.2855 3.09773 19.1462 3.30117C18.8678 3.70798 18.5006 4.30841 18.1348 5.09551C17.4027 6.67071 16.6765 8.99234 16.6765 12L17.6765 12C17.6765 9.15766 18.362 6.97929 19.0417 5.51699C19.3817 4.78534 19.7205 4.23265 19.9714 3.86601C20.0969 3.68274 20.2003 3.54612 20.2708 3.45706C20.306 3.41253 20.333 3.37992 20.3504 3.35932C20.3591 3.34902 20.3654 3.34173 20.3691 3.33746C20.3709 3.33532 20.3721 3.33395 20.3727 3.33332C20.373 3.33301 20.3731 3.33289 20.373 3.33296C20.373 3.33299 20.3729 3.33307 20.3728 3.3332C20.3727 3.33327 20.3726 3.3334 20.3726 3.33343C20.3725 3.33358 20.3723 3.33373 20 3ZM16.6765 12C16.6765 15.0077 17.4027 17.3293 18.1348 18.9045C18.5006 19.6916 18.8678 20.292 19.1462 20.6988C19.2855 20.9023 19.4027 21.0575 19.4866 21.1635C19.5286 21.2165 19.5622 21.2573 19.5862 21.2857C19.5982 21.2999 19.6078 21.311 19.6147 21.319C19.6182 21.323 19.6211 21.3263 19.6232 21.3287C19.6243 21.3299 19.6252 21.331 19.626 21.3318C19.6263 21.3322 19.6267 21.3326 19.6269 21.3329C19.6271 21.3331 19.6273 21.3333 19.6273 21.3334C19.6275 21.3336 19.6277 21.3337 20 21C20.3723 20.6663 20.3725 20.6664 20.3726 20.6666C20.3726 20.6666 20.3727 20.6667 20.3728 20.6668C20.3729 20.6669 20.373 20.667 20.373 20.667C20.3731 20.6671 20.373 20.667 20.3727 20.6667C20.3721 20.6661 20.3709 20.6647 20.3691 20.6625C20.3654 20.6583 20.3591 20.651 20.3504 20.6407C20.333 20.6201 20.306 20.5875 20.2708 20.5429C20.2003 20.4539 20.0969 20.3173 19.9714 20.134C19.7205 19.7674 19.3817 19.2147 19.0417 18.483C18.362 17.0207 17.6765 14.8423 17.6765 12L16.6765 12Z"
          fill="#585858"
          className={"icon_fill"}
        />
      </svg>
    </>
  );
};

export const FlowchartDelay = ({ ...props }) => {
  return (
    <>
      <svg
        onClick={props.onClick}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.5 3C2.5 2.72386 2.72386 2.5 3 2.5H13C17.6944 2.5 21.5 6.30558 21.5 11V13C21.5 17.6944 17.6944 21.5 13 21.5H3C2.72386 21.5 2.5 21.2761 2.5 21V3ZM3.5 3.5V20.5H13C17.1421 20.5 20.5 17.1421 20.5 13V11C20.5 6.85786 17.1421 3.5 13 3.5H3.5Z"
          fill="#585858"
          className={"icon_fill"}
        />
      </svg>
    </>
  );
};

export const FlowchartAccessStorage = ({ ...props }) => {
  return (
    <>
      <svg
        onClick={props.onClick}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M20 18L19.6002 17.6997L18.999 18.5H20V18ZM22 18H22.5V17.5H22V18ZM22 22V22.5H22.5V22H22ZM12 21.5C6.75329 21.5 2.5 17.2467 2.5 12H1.5C1.5 17.799 6.20101 22.5 12 22.5V21.5ZM2.5 12C2.5 6.75329 6.75329 2.5 12 2.5V1.5C6.20101 1.5 1.5 6.20101 1.5 12H2.5ZM12 2.5C17.2467 2.5 21.5 6.75329 21.5 12H22.5C22.5 6.20101 17.799 1.5 12 1.5V2.5ZM21.5 12C21.5 14.1393 20.793 16.1119 19.6002 17.6997L20.3998 18.3003C21.7181 16.5454 22.5 14.3635 22.5 12H21.5ZM20 18.5H22V17.5H20V18.5ZM21.5 18V22H22.5V18H21.5ZM22 21.5H12V22.5H22V21.5Z"
          fill="#585858"
          className={"icon_fill"}
        />
      </svg>
    </>
  );
};

export const FlowchartMagneticDisc = ({ ...props }) => {
  return (
    <>
      <svg
        onClick={props.onClick}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M4 5L3.55279 4.77639C3.51807 4.84582 3.5 4.92238 3.5 5H4ZM20 5H20.5C20.5 4.92238 20.4819 4.84582 20.4472 4.77639L20 5ZM4 19H3.5C3.5 19.0537 3.50866 19.1071 3.52566 19.1581L4 19ZM20 19L20.4743 19.1581C20.4913 19.1071 20.5 19.0537 20.5 19H20ZM12 21.5C8.56995 21.5 6.67417 20.7652 5.65235 20.084C5.14085 19.743 4.84007 19.4101 4.67096 19.176C4.58608 19.0585 4.53349 18.9646 4.50385 18.9053C4.48903 18.8756 4.47992 18.8546 4.47538 18.8436C4.47312 18.8381 4.47199 18.835 4.47187 18.8347C4.4718 18.8345 4.47199 18.835 4.47241 18.8362C4.47262 18.8368 4.47288 18.8376 4.47321 18.8385C4.47337 18.839 4.47354 18.8395 4.47373 18.8401C4.47383 18.8404 4.47398 18.8408 4.47403 18.8409C4.47418 18.8414 4.47434 18.8419 4 19C3.52566 19.1581 3.52582 19.1586 3.526 19.1591C3.52606 19.1593 3.52623 19.1598 3.52636 19.1602C3.52661 19.1609 3.52688 19.1617 3.52716 19.1626C3.52774 19.1642 3.52838 19.1661 3.5291 19.1681C3.53053 19.1722 3.53226 19.177 3.5343 19.1825C3.53838 19.1935 3.54373 19.2074 3.55049 19.2238C3.56402 19.2567 3.58324 19.3001 3.60943 19.3525C3.66183 19.4573 3.74205 19.5978 3.86029 19.7615C4.09743 20.0899 4.48415 20.507 5.09765 20.916C6.32583 21.7348 8.43005 22.5 12 22.5V21.5ZM4.5 19V5H3.5V19H4.5ZM19.5 5V19H20.5V5H19.5ZM20 19C19.5257 18.8419 19.5258 18.8414 19.526 18.8409C19.526 18.8408 19.5262 18.8404 19.5263 18.8401C19.5265 18.8395 19.5266 18.839 19.5268 18.8385C19.5271 18.8376 19.5274 18.8368 19.5276 18.8362C19.528 18.835 19.5282 18.8345 19.5281 18.8347C19.528 18.835 19.5269 18.8381 19.5246 18.8436C19.5201 18.8546 19.511 18.8756 19.4961 18.9053C19.4665 18.9646 19.4139 19.0585 19.329 19.176C19.1599 19.4101 18.8592 19.743 18.3476 20.084C17.3258 20.7652 15.4301 21.5 12 21.5V22.5C15.5699 22.5 17.6742 21.7348 18.9024 20.916C19.5158 20.507 19.9026 20.0899 20.1397 19.7615C20.258 19.5978 20.3382 19.4573 20.3906 19.3525C20.4168 19.3001 20.436 19.2567 20.4495 19.2238C20.4563 19.2074 20.4616 19.1935 20.4657 19.1825C20.4677 19.177 20.4695 19.1722 20.4709 19.1681C20.4716 19.1661 20.4723 19.1642 20.4728 19.1626C20.4731 19.1617 20.4734 19.1609 20.4736 19.1602C20.4738 19.1598 20.4739 19.1593 20.474 19.1591C20.4742 19.1586 20.4743 19.1581 20 19ZM4 5C4.44721 5.22361 4.44703 5.22397 4.44685 5.22433C4.4468 5.22443 4.44663 5.22478 4.44652 5.22499C4.44631 5.2254 4.44612 5.22577 4.44596 5.2261C4.44563 5.22675 4.44538 5.22722 4.44523 5.22752C4.44492 5.22812 4.44497 5.22802 4.44538 5.22724C4.44621 5.22569 4.44852 5.22143 4.45241 5.21464C4.46018 5.20106 4.47425 5.17737 4.49546 5.14499C4.53786 5.08023 4.60878 4.98066 4.71482 4.85751C4.92654 4.61164 5.27994 4.26983 5.8295 3.92274C6.92518 3.23073 8.82937 2.5 12 2.5V1.5C8.67063 1.5 6.57482 2.26927 5.2955 3.07726C4.65756 3.48017 4.22971 3.88836 3.95705 4.20499C3.82091 4.36309 3.72386 4.4979 3.65884 4.5972C3.62633 4.64685 3.60184 4.68761 3.58446 4.71798C3.57577 4.73316 3.56886 4.74575 3.56362 4.75555C3.561 4.76045 3.5588 4.76465 3.55699 4.76813C3.55609 4.76987 3.55529 4.77143 3.55459 4.77281C3.55424 4.7735 3.55392 4.77414 3.55362 4.77474C3.55347 4.77504 3.55326 4.77545 3.55318 4.7756C3.55298 4.776 3.55279 4.77639 4 5ZM12 2.5C15.1706 2.5 17.0748 3.23073 18.1705 3.92274C18.7201 4.26983 19.0735 4.61164 19.2852 4.85751C19.3912 4.98066 19.4621 5.08023 19.5045 5.14499C19.5257 5.17737 19.5398 5.20106 19.5476 5.21464C19.5515 5.22143 19.5538 5.22569 19.5546 5.22724C19.555 5.22802 19.5551 5.22812 19.5548 5.22752C19.5546 5.22722 19.5544 5.22675 19.554 5.2261C19.5539 5.22577 19.5537 5.2254 19.5535 5.22499C19.5534 5.22478 19.5532 5.22443 19.5531 5.22433C19.553 5.22397 19.5528 5.22361 20 5C20.4472 4.77639 20.447 4.776 20.4468 4.7756C20.4467 4.77545 20.4465 4.77504 20.4464 4.77474C20.4461 4.77414 20.4458 4.7735 20.4454 4.77281C20.4447 4.77143 20.4439 4.76987 20.443 4.76813C20.4412 4.76465 20.439 4.76045 20.4364 4.75555C20.4311 4.74575 20.4242 4.73316 20.4155 4.71798C20.3982 4.68761 20.3737 4.64685 20.3412 4.5972C20.2761 4.4979 20.1791 4.36309 20.0429 4.20499C19.7703 3.88836 19.3424 3.48017 18.7045 3.07726C17.4252 2.26927 15.3294 1.5 12 1.5V2.5ZM4 5C3.55279 5.22361 3.55298 5.224 3.55318 5.2244C3.55326 5.22455 3.55347 5.22496 3.55362 5.22526C3.55392 5.22586 3.55424 5.2265 3.55459 5.22719C3.55529 5.22857 3.55609 5.23013 3.55699 5.23187C3.5588 5.23535 3.561 5.23955 3.56362 5.24445C3.56886 5.25425 3.57577 5.26684 3.58446 5.28202C3.60184 5.31239 3.62633 5.35315 3.65884 5.4028C3.72386 5.5021 3.82091 5.63691 3.95705 5.79501C4.22971 6.11164 4.65756 6.51983 5.2955 6.92274C6.57482 7.73073 8.67063 8.5 12 8.5V7.5C8.82937 7.5 6.92518 6.76927 5.8295 6.07726C5.27994 5.73017 4.92654 5.38836 4.71482 5.14249C4.60878 5.01934 4.53786 4.91977 4.49546 4.85501C4.47425 4.82263 4.46018 4.79894 4.45241 4.78536C4.44852 4.77857 4.44621 4.77431 4.44538 4.77276C4.44497 4.77198 4.44492 4.77188 4.44523 4.77248C4.44538 4.77278 4.44563 4.77325 4.44596 4.7739C4.44612 4.77423 4.44631 4.7746 4.44652 4.77501C4.44663 4.77522 4.4468 4.77557 4.44685 4.77567C4.44703 4.77603 4.44721 4.77639 4 5ZM12 8.5C15.3294 8.5 17.4252 7.73073 18.7045 6.92274C19.3424 6.51983 19.7703 6.11164 20.0429 5.79501C20.1791 5.63691 20.2761 5.5021 20.3412 5.4028C20.3737 5.35315 20.3982 5.31239 20.4155 5.28202C20.4242 5.26684 20.4311 5.25425 20.4364 5.24445C20.439 5.23955 20.4412 5.23535 20.443 5.23187C20.4439 5.23013 20.4447 5.22857 20.4454 5.22719C20.4458 5.2265 20.4461 5.22586 20.4464 5.22526C20.4465 5.22496 20.4467 5.22455 20.4468 5.2244C20.447 5.224 20.4472 5.22361 20 5C19.5528 4.77639 19.553 4.77603 19.5531 4.77567C19.5532 4.77557 19.5534 4.77522 19.5535 4.77501C19.5537 4.7746 19.5539 4.77423 19.554 4.7739C19.5544 4.77325 19.5546 4.77278 19.5548 4.77248C19.5551 4.77188 19.555 4.77198 19.5546 4.77276C19.5538 4.77431 19.5515 4.77857 19.5476 4.78536C19.5398 4.79894 19.5257 4.82263 19.5045 4.85501C19.4621 4.91977 19.3912 5.01934 19.2852 5.14249C19.0735 5.38836 18.7201 5.73017 18.1705 6.07726C17.0748 6.76927 15.1706 7.5 12 7.5V8.5Z"
          fill="#585858"
          className={"icon_fill"}
        />
      </svg>
    </>
  );
};

export const FlowchartDirectAccessStorage = ({ ...props }) => {
  return (
    <>
      <svg
        onClick={props.onClick}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M19 4L19.2236 3.55279C19.1542 3.51807 19.0776 3.5 19 3.5L19 4ZM19 20L19 20.5C19.0776 20.5 19.1542 20.4819 19.2236 20.4472L19 20ZM5 4L5 3.5C4.94626 3.5 4.89287 3.50866 4.84189 3.52566L5 4ZM5 20L4.84189 20.4743C4.89287 20.4913 4.94626 20.5 5 20.5L5 20ZM2.5 12C2.5 8.56995 3.23482 6.67417 3.91603 5.65235C4.25703 5.14085 4.58985 4.84007 4.824 4.67096C4.94153 4.58608 5.03543 4.53349 5.0947 4.50385C5.12436 4.48903 5.14539 4.47992 5.15643 4.47538C5.16194 4.47312 5.16496 4.47199 5.1653 4.47186C5.16547 4.4718 5.16497 4.47199 5.16378 4.47241C5.16318 4.47262 5.16242 4.47288 5.16147 4.47321C5.161 4.47337 5.16049 4.47354 5.15993 4.47373C5.15965 4.47383 5.15919 4.47398 5.15905 4.47403C5.15859 4.47418 5.15811 4.47434 5 4C4.84189 3.52566 4.84139 3.52582 4.84088 3.52599C4.84069 3.52606 4.84017 3.52623 4.8398 3.52636C4.83906 3.52661 4.83827 3.52688 4.83743 3.52716C4.83576 3.52773 4.83391 3.52838 4.83187 3.52909C4.8278 3.53053 4.823 3.53226 4.81749 3.5343C4.80648 3.53838 4.79265 3.54373 4.77619 3.55049C4.74328 3.56402 4.69986 3.58324 4.64749 3.60943C4.54269 3.66182 4.40222 3.74205 4.2385 3.86028C3.91015 4.09743 3.49297 4.48415 3.08397 5.09765C2.26518 6.32583 1.5 8.43005 1.5 12L2.5 12ZM5 4.5L19 4.5L19 3.5L5 3.5L5 4.5ZM19 19.5L5 19.5L5 20.5L19 20.5L19 19.5ZM5 20C5.15811 19.5257 5.15859 19.5258 5.15905 19.526C5.15919 19.526 5.15965 19.5262 5.15992 19.5263C5.16049 19.5265 5.161 19.5266 5.16147 19.5268C5.16242 19.5271 5.16318 19.5274 5.16378 19.5276C5.16497 19.528 5.16547 19.5282 5.1653 19.5281C5.16496 19.528 5.16194 19.5269 5.15642 19.5246C5.14539 19.5201 5.12436 19.511 5.0947 19.4961C5.03543 19.4665 4.94153 19.4139 4.82399 19.329C4.58985 19.1599 4.25703 18.8592 3.91602 18.3476C3.23482 17.3258 2.5 15.4301 2.5 12L1.5 12C1.5 15.5699 2.26518 17.6742 3.08397 18.9023C3.49297 19.5158 3.91015 19.9026 4.2385 20.1397C4.40222 20.258 4.54269 20.3382 4.64749 20.3906C4.69986 20.4168 4.74328 20.436 4.77619 20.4495C4.79265 20.4563 4.80648 20.4616 4.81749 20.4657C4.823 20.4677 4.8278 20.4695 4.83187 20.4709C4.83391 20.4716 4.83576 20.4723 4.83743 20.4728C4.83827 20.4731 4.83906 20.4734 4.8398 20.4736C4.84017 20.4738 4.84069 20.4739 4.84088 20.474C4.84139 20.4742 4.84189 20.4743 5 20ZM19 4C18.7764 4.44721 18.776 4.44703 18.7757 4.44685C18.7756 4.4468 18.7752 4.44663 18.775 4.44652C18.7746 4.44631 18.7742 4.44612 18.7739 4.44596C18.7733 4.44563 18.7728 4.44538 18.7725 4.44523C18.7719 4.44492 18.772 4.44497 18.7728 4.44538C18.7743 4.44621 18.7786 4.44852 18.7854 4.45241C18.7989 4.46018 18.8226 4.47425 18.855 4.49546C18.9198 4.53786 19.0193 4.60878 19.1425 4.71482C19.3884 4.92654 19.7302 5.27994 20.0773 5.8295C20.7693 6.92518 21.5 8.82937 21.5 12L22.5 12C22.5 8.67063 21.7307 6.57482 20.9227 5.2955C20.5198 4.65756 20.1116 4.22971 19.795 3.95705C19.6369 3.82091 19.5021 3.72386 19.4028 3.65884C19.3532 3.62633 19.3124 3.60184 19.282 3.58446C19.2668 3.57577 19.2543 3.56886 19.2445 3.56362C19.2396 3.561 19.2354 3.5588 19.2319 3.55699C19.2301 3.55609 19.2286 3.55529 19.2272 3.55459C19.2265 3.55424 19.2259 3.55392 19.2253 3.55362C19.225 3.55347 19.2245 3.55326 19.2244 3.55318C19.224 3.55298 19.2236 3.55279 19 4ZM21.5 12C21.5 15.1706 20.7693 17.0748 20.0773 18.1705C19.7302 18.7201 19.3884 19.0735 19.1425 19.2852C19.0193 19.3912 18.9198 19.4621 18.855 19.5045C18.8226 19.5257 18.7989 19.5398 18.7854 19.5476C18.7786 19.5515 18.7743 19.5538 18.7728 19.5546C18.772 19.555 18.7719 19.5551 18.7725 19.5548C18.7728 19.5546 18.7733 19.5544 18.7739 19.554C18.7742 19.5539 18.7746 19.5537 18.775 19.5535C18.7752 19.5534 18.7756 19.5532 18.7757 19.5531C18.776 19.553 18.7764 19.5528 19 20C19.2236 20.4472 19.224 20.447 19.2244 20.4468C19.2245 20.4467 19.225 20.4465 19.2253 20.4464C19.2259 20.4461 19.2265 20.4458 19.2272 20.4454C19.2286 20.4447 19.2301 20.4439 19.2319 20.443C19.2354 20.4412 19.2396 20.439 19.2445 20.4364C19.2543 20.4311 19.2668 20.4242 19.282 20.4155C19.3124 20.3982 19.3532 20.3737 19.4028 20.3412C19.5021 20.2761 19.6369 20.1791 19.795 20.0429C20.1116 19.7703 20.5198 19.3424 20.9227 18.7045C21.7307 17.4252 22.5 15.3294 22.5 12L21.5 12ZM19 4C18.7764 3.55279 18.776 3.55298 18.7756 3.55318C18.7755 3.55326 18.775 3.55347 18.7747 3.55362C18.7741 3.55392 18.7735 3.55424 18.7728 3.55459C18.7714 3.55529 18.7699 3.55609 18.7681 3.55699C18.7646 3.5588 18.7604 3.561 18.7555 3.56362C18.7457 3.56886 18.7332 3.57577 18.718 3.58446C18.6876 3.60184 18.6468 3.62633 18.5972 3.65884C18.4979 3.72386 18.3631 3.82091 18.205 3.95705C17.8884 4.22971 17.4802 4.65756 17.0773 5.2955C16.2693 6.57482 15.5 8.67063 15.5 12L16.5 12C16.5 8.82937 17.2307 6.92518 17.9227 5.8295C18.2698 5.27994 18.6116 4.92654 18.8575 4.71482C18.9807 4.60878 19.0802 4.53786 19.145 4.49546C19.1774 4.47425 19.2011 4.46018 19.2146 4.45241C19.2214 4.44852 19.2257 4.44621 19.2272 4.44538C19.228 4.44497 19.2281 4.44492 19.2275 4.44523C19.2272 4.44538 19.2267 4.44563 19.2261 4.44596C19.2258 4.44612 19.2254 4.44631 19.225 4.44652C19.2248 4.44663 19.2244 4.4468 19.2243 4.44685C19.224 4.44703 19.2236 4.44721 19 4ZM15.5 12C15.5 15.3294 16.2693 17.4252 17.0773 18.7045C17.4802 19.3424 17.8884 19.7703 18.205 20.0429C18.3631 20.1791 18.4979 20.2761 18.5972 20.3412C18.6468 20.3737 18.6876 20.3982 18.718 20.4155C18.7332 20.4242 18.7457 20.4311 18.7555 20.4364C18.7604 20.439 18.7646 20.4412 18.7681 20.443C18.7699 20.4439 18.7714 20.4447 18.7728 20.4454C18.7735 20.4458 18.7741 20.4461 18.7747 20.4464C18.775 20.4465 18.7755 20.4467 18.7756 20.4468C18.776 20.447 18.7764 20.4472 19 20C19.2236 19.5528 19.224 19.553 19.2243 19.5531C19.2244 19.5532 19.2248 19.5534 19.225 19.5535C19.2254 19.5537 19.2258 19.5539 19.2261 19.554C19.2267 19.5544 19.2272 19.5546 19.2275 19.5548C19.2281 19.5551 19.228 19.555 19.2272 19.5546C19.2257 19.5538 19.2214 19.5515 19.2146 19.5476C19.2011 19.5398 19.1774 19.5257 19.145 19.5045C19.0802 19.4621 18.9807 19.3912 18.8575 19.2852C18.6116 19.0735 18.2698 18.7201 17.9227 18.1705C17.2307 17.0748 16.5 15.1706 16.5 12L15.5 12Z"
          fill="#585858"
          className={"icon_fill"}
        />
      </svg>
    </>
  );
};

export const FlowchartDisplay = ({ ...props }) => {
  return (
    <>
      <svg
        onClick={props.onClick}
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7 3V2.5C6.83282 2.5 6.67671 2.58355 6.58397 2.72265L7 3ZM7 21L6.58397 21.2773C6.67671 21.4164 6.83282 21.5 7 21.5V21ZM1 12L0.583975 11.7226C0.472008 11.8906 0.472008 12.1094 0.583975 12.2774L1 12ZM7 3.5H19V2.5H7V3.5ZM22.5 7V17H23.5V7H22.5ZM19 20.5H7V21.5H19V20.5ZM7.41603 20.7227L1.41603 11.7226L0.583975 12.2774L6.58397 21.2773L7.41603 20.7227ZM1.41603 12.2774L7.41603 3.27735L6.58397 2.72265L0.583975 11.7226L1.41603 12.2774ZM22.5 17C22.5 18.933 20.933 20.5 19 20.5V21.5C21.4853 21.5 23.5 19.4853 23.5 17H22.5ZM19 3.5C20.933 3.5 22.5 5.067 22.5 7H23.5C23.5 4.51472 21.4853 2.5 19 2.5V3.5Z"
          fill="#585858"
          className={"icon_fill"}
        />
      </svg>
    </>
  );
};
